import React, { useState, useEffect } from "react";
import "../css/modal.css";
import { IoWarningOutline } from "react-icons/io5";
import EmailService from "../../modules/services/EmailService";

function ModalNFe({ isOpen, onClose, cliente, onClienteUpdate }) {
    const [emails, setEmails] = useState({
        principal: "",
        copia: "",
    });

    const [agree, setAgree] = useState(false);

    // Atualiza os emails quando o modal abre ou quando o cliente muda
    useEffect(() => {
        if (isOpen && cliente) {
            const emailPrincipal = cliente.emails.find(email => email.dsCategoriaEmail === "NFE PRINCIPAL")?.dsEmail || "";
            const emailCopia = cliente.emails.find(email => email.dsCategoriaEmail === "NFE COPIA")?.dsEmail || "";
            setEmails({
                principal: emailPrincipal,
                copia: emailCopia,
            });
        }
    }, [isOpen, cliente]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!agree) {
            alert("Você precisa concordar com os termos.");
            return;
        }

        try {
            // Verifica se os novos emails são diferentes dos atuais
            const emailsToUpdate = {
                principal: emails.principal,
                copia: emails.copia,
                boleto: emails.boleto,
                nmResponsavel: cliente.razaoSocial,
            };

            const emailsUpdated = {};

            if (emailsToUpdate.principal !== cliente?.emails.find(email => email.dsCategoriaEmail === "NFE PRINCIPAL")?.dsEmail) {
                emailsUpdated.principal = emailsToUpdate.principal;
            }

            if (emailsToUpdate.copia !== cliente?.emails.find(email => email.dsCategoriaEmail === "NFE COPIA")?.dsEmail) {
                emailsUpdated.copia = emailsToUpdate.copia;
            }

            // Se o email do boleto foi fornecido, verifica se ele é diferente do atual
            if (emailsToUpdate.boleto && emailsToUpdate.boleto !== cliente?.emails.find(email => email.cdCategoriaEmail === 43)?.dsEmail) {
                emailsUpdated.boleto = emailsToUpdate.boleto;
            }

            // Se não houve alterações em nenhum dos campos de email
            if (Object.keys(emailsUpdated).length === 0) {
                alert("Nenhuma alteração nos e-mails.");
                return;
            }

            // Envia os emails atualizados
            await EmailService.atualizarEmails(cliente.cdCliente, {
                ...emailsUpdated,
                nmResponsavel: cliente.razaoSocial,
            });

            alert("Emails atualizados com sucesso!");
            if (onClienteUpdate) {
                await onClienteUpdate();
            }
            onClose();
        } catch (error) {
            alert("Erro ao atualizar emails.");
        }
    };


    return (
        <div className="modal">
            <div className="modal-content">
                <div className="topoModal">
                    <button className="modal-close" onClick={onClose}>✖</button>
                    <h3><b>Editar emails NF-e e Boleto</b></h3>
                </div>
                <p>Digite os novos endereços de e-mail (se preferir, você pode alterar somente um).</p>

                <label><b>E-mail principal envio NF-e</b></label>
                <input
                    type="email"
                    placeholder="Digite o novo e-mail"
                    value={emails.principal}
                    onChange={(e) => setEmails({ ...emails, principal: e.target.value })}
                />

                <label><b>E-mail secundário envio NF-e</b></label>
                <input
                    type="email"
                    placeholder="Digite o novo e-mail"
                    value={emails.copia}
                    onChange={(e) => setEmails({ ...emails, copia: e.target.value })}
                />

                <div className="modal-alert">
                    <IoWarningOutline size={70} />
                    Caso você não confirme a alteração pelo link enviado ao novo e-mail, seu endereço de e-mail atual permanecerá o mesmo.
                </div>

                <p>O endereço eletrônico para envio da Nota Fiscal Eletrônica é de responsabilidade do informante.</p>

                <div className="modal-checkbox">
                    <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                    <label className="textoAceite">Estou ciente destas obrigações e concordo</label>
                </div>

                <div className="modal-actions">
                    <button className="cancel" onClick={onClose}>Cancelar</button>
                    <button 
                        className={`confirm ${!agree ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={!agree}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalNFe;
